import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { getSitePreviewPassword } from "../lib/sitePreview";

const STORAGE_KEY = "jobuwin_preview_ok";

/**
 * Optional site-wide preview password. When unset, the gate is off (crawler-friendly + local dev).
 * Job detail routes are also mounted outside this gate in `App.jsx` so `/jobs/*` stays reachable when a password is set.
 */
export default function PreviewPasswordGate() {
  const expected = getSitePreviewPassword();
  const [unlocked, setUnlocked] = useState(false);
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!expected) return;
    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      setUnlocked(true);
    }
  }, [expected]);

  if (!expected) {
    return <Outlet />;
  }

  if (unlocked) {
    return <Outlet />;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    if (value === expected) {
      sessionStorage.setItem(STORAGE_KEY, "1");
      setUnlocked(true);
      setError("");
    } else {
      setError("That password is not correct.");
    }
  };

  return (
    <main className="preview-gate-page">
      <div className="preview-gate-card">
        <h1 className="preview-gate-title">Private preview</h1>
        <p className="preview-gate-copy">
          App pages are not public yet. Enter the preview password to continue.
        </p>
        <form className="preview-gate-form" onSubmit={handleSubmit}>
          <label className="preview-gate-label" htmlFor="preview-password">
            Password
          </label>
          <input
            id="preview-password"
            className="preview-gate-input"
            type="password"
            name="password"
            autoComplete="current-password"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          {error ? (
            <p className="preview-gate-error" role="alert">
              {error}
            </p>
          ) : null}
          <button type="submit" className="preview-gate-submit">
            Continue
          </button>
        </form>
      </div>
    </main>
  );
}
